export type NotificationCategory =
  | "purchase"
  | "sale"
  | "dispute"
  | "review"
  | "withdrawal"
  | "deposit"
  | "ticket"
  | "system"
  | "penalty"
  | "default";

export const NOTIFICATION_COLORS: Record<
  NotificationCategory,
  {
    bg: string;
    icon: string;
    border: string;
    unreadBg: string;
    unreadBorder: string;
  }
> = {
  purchase: {
    bg: "bg-blue-500/10",
    icon: "text-blue-500",
    border: "border-blue-500/20",
    unreadBg: "bg-blue-500/15",
    unreadBorder: "border-blue-500/30",
  },
  sale: {
    bg: "bg-green-500/10",
    icon: "text-green-500",
    border: "border-green-500/20",
    unreadBg: "bg-green-500/15",
    unreadBorder: "border-green-500/30",
  },
  dispute: {
    bg: "bg-amber-500/10",
    icon: "text-amber-500",
    border: "border-amber-500/20",
    unreadBg: "bg-amber-500/15",
    unreadBorder: "border-amber-500/30",
  },
  review: {
    bg: "bg-yellow-500/10",
    icon: "text-yellow-500",
    border: "border-yellow-500/20",
    unreadBg: "bg-yellow-500/15",
    unreadBorder: "border-yellow-500/30",
  },
  withdrawal: {
    bg: "bg-purple-500/10",
    icon: "text-purple-500",
    border: "border-purple-500/20",
    unreadBg: "bg-purple-500/15",
    unreadBorder: "border-purple-500/30",
  },
  deposit: {
    bg: "bg-emerald-500/10",
    icon: "text-emerald-500",
    border: "border-emerald-500/20",
    unreadBg: "bg-emerald-500/15",
    unreadBorder: "border-emerald-500/30",
  },
  ticket: {
    bg: "bg-cyan-500/10",
    icon: "text-cyan-500",
    border: "border-cyan-500/20",
    unreadBg: "bg-cyan-500/15",
    unreadBorder: "border-cyan-500/30",
  },
  system: {
    bg: "bg-rose-500/10",
    icon: "text-rose-500",
    border: "border-rose-500/20",
    unreadBg: "bg-rose-500/15",
    unreadBorder: "border-rose-500/30",
  },
  penalty: {
    bg: "bg-amber-500/10",
    icon: "text-amber-500",
    border: "border-amber-500/20",
    unreadBg: "bg-amber-500/15",
    unreadBorder: "border-amber-500/30",
  },
  default: {
    bg: "bg-muted",
    icon: "text-muted-foreground",
    border: "",
    unreadBg: "bg-accent",
    unreadBorder: "border-primary/30",
  },
};

export function getNotificationCategory(type: string): NotificationCategory {
  if (type.startsWith("purchase_")) return "purchase";
  if (type.startsWith("sale_")) return "sale";
  if (type.startsWith("dispute_")) return "dispute";
  if (type.startsWith("review_")) return "review";
  if (type.startsWith("withdrawal_")) return "withdrawal";
  if (type.startsWith("deposit_")) return "deposit";
  if (type.startsWith("ticket_")) return "ticket";
  if (type.startsWith("system_")) return "system";
  if (type.startsWith("escrow_")) return "sale";
  if (type.startsWith("transaction_")) return "purchase";
  if (type.startsWith("reservation_")) return "purchase";
  if (type.startsWith("account_files_")) return "system";
  if (type.startsWith("penalty_")) return "penalty";
  return "default";
}

export function getNotificationColors(type: string, unread: boolean) {
  const category = getNotificationCategory(type);
  const colors = NOTIFICATION_COLORS[category];
  return {
    bg: unread ? colors.unreadBg : colors.bg,
    border: unread ? colors.unreadBorder : colors.border,
    icon: colors.icon,
  };
}
